import {
  Backdrop,
  Box,
  Checkbox,
  CircularProgress,
  InputAdornment,
  Typography,
} from "@mui/material";
import { MagnifyingGlass, Warning, X } from "@phosphor-icons/react";
import React from "react";
import { Controller } from "react-hook-form";
import useUpdateStaff from "./useUpdateStaff.js";
import { staffStyle } from "../staffStyle.js";
import SPADialogue from "../../../../../common/spa-dialogue/index.jsx";
import SPATextField from "../../../../../common/spa-textField/index.jsx";
import NoClients from "../../../../../../assets/svg/no-clients.jsx";
import { lightenHexColor } from "../../../../../../utils/convertLightenHexColor.js";

export default function UpdateProductDialog({
  isAddQualificationOpen,
  handleClose,
  singleQualificationId,
  setIsOpenSuccessDialog,
  dialogTitle,
  contentTitle,
  subContentDescription,
  type,
  submitText = "Add Qualification",
}) {
  const {
    searchTherapist,
    setSearchTherapist,
    methods,
    handleSubmit,
    onSubmit,
    handleCloseForm,
    errors,
    productsData,
    productsDataLoader,
  } = useUpdateStaff(
    handleClose,
    singleQualificationId,
    setIsOpenSuccessDialog,
    type
  );

  return (
    <>
      <SPADialogue
        open={isAddQualificationOpen}
        handleClose={handleCloseForm}
        dialogTitle={dialogTitle ?? "Title"}
        cancelText="Cancel"
        submitText={submitText}
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}
        methods={methods}
      >
        {productsDataLoader && (
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 3 }}
            open={productsDataLoader}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box sx={staffStyle.addQualificationHeaderMain}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                // p: "16px",
              }}
            >
              <Typography
                sx={{
                  color: "#4A4C4F",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
              >
                {contentTitle ?? "Title"}
              </Typography>
              <Typography
                sx={{
                  color: "#5E6062",
                  fontSize: "12px",
                }}
              >
                {/* Please select the therapists you want to add this qualification
                to. */}
                {subContentDescription ?? "Description Here"}
              </Typography>
            </Box>
            {type === "Product" && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  p: "16px",
                  border: "1px solid #FA9200",
                  borderRadius: "8px",
                  bgcolor: "#FFF9F0",
                }}
              >
                <Warning size={16} color={"#FA9200"} />
                <Typography
                  sx={{
                    color: "#DB8000",
                    fontSize: "14px",
                  }}
                >
                  If the product already have a product type, it will be
                  replaced with this one.
                </Typography>
              </Box>
            )}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
                flexWrap: "wrap",
                width: "100%",
              }}
            >
              <SPATextField
                placeholder={`Search ${contentTitle ?? "Title"}`}
                value={searchTherapist}
                fullWidth={true}
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      sx={{ paddingLeft: "10px" }}
                    >
                      <MagnifyingGlass size={24} color={"#C1C2C3"} />
                    </InputAdornment>
                  ),

                  endAdornment: (
                    <InputAdornment
                      position="end"
                      sx={{ paddingLeft: "10px", cursor: "pointer" }}
                      onClick={() => {
                        setSearchTherapist("");
                      }}
                    >
                      {searchTherapist && <X size={24} />}
                    </InputAdornment>
                  ),
                }}
                onChangeValue={(event) => {
                  setSearchTherapist(event.target.value);
                }}
              />
            </Box>
            <Box
              sx={{
                width: "688px",
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                maxHeight: "43vh",
                overflowY: "auto",
              }}
            >
              {productsData?.result?.data?.data?.map((item) => {
                return (
                  <Controller
                    key={item._id}
                    name={"productIds"}
                    control={methods.control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <Box
                        sx={{
                          borderRadius: "4px",
                          bgcolor: "#FFFFFF",
                          px: "8px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          const currentValue = Array.isArray(value)
                            ? value
                            : [];
                          const newValue = currentValue.includes(item._id)
                            ? currentValue.filter((id) => id !== item._id)
                            : [...currentValue, item._id];
                          onChange(newValue);
                        }}
                      >
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Checkbox
                            sx={{
                              "&.Mui-checked": {
                                color: "#4E45E5",
                              },
                            }}
                            checked={
                              Array.isArray(value) && value.includes(item._id)
                            }
                            onChange={(e) => {
                              e.stopPropagation();
                            }}
                            onBlur={onBlur}
                          />
                          <Typography
                            sx={{ color: "#070A0E", fontSize: "12px" }}
                          >
                            {`${item.name}`}
                          </Typography>
                        </Box>
                      </Box>
                    )}
                  />
                );
              })}

              {productsData &&
                productsData?.result?.data?.data?.length === 0 &&
                !productsDataLoader && (
                  <Box
                    sx={{
                      mt: "18px",
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "24px",
                    }}
                  >
                    <NoClients />
                    <Typography sx={{ fontSize: "20px", color: "#595959" }}>
                      There’s no {contentTitle ?? "Title"} yet
                    </Typography>
                    <Typography sx={{ fontSize: "14px", color: "#595959" }}>
                      After creating {contentTitle ?? "Title"}, they will be
                      displayed here as {contentTitle ?? "Title"}.
                    </Typography>
                  </Box>
                )}
            </Box>
          </Box>
          {errors["productIds"] && (
            <Typography
              sx={{
                color: "#FFAA33",
                fontSize: "12px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                mt: "5px",
              }}
              color="error"
            >
              <Warning color={"#FFAA33"} size={16} />{" "}
              {errors["productIds"].message}
            </Typography>
          )}
        </Box>
      </SPADialogue>
    </>
  );
}
